module.exports = __webpack_public_path__ + "img/ic-plus-white.3431138c.svg";